import * as PropTypes from 'prop-types';

const Label = ({ id, label, required = false }: { id: string; label: string; required?: boolean }) => {
    if (!label) {
        return <></>;
    }

    return (
        <label className={required ? 'is-required' : undefined} htmlFor={id}>
            {' '}
            {label}
        </label>
    );
};

Label.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.object]).isRequired,
    required: PropTypes.bool
};

export default Label;
